import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import Create from './Create'
import Delete from './Delete'
import Update from './Update'

import { useAppDispatch, useAppSelector } from '@store/hooks'
import {
  createMembershipProfileTag,
  deleteMembershipProfileTag,
  updateMembershipProfileTag,
} from '@store/membership/MembershipProfileTagReducer'

export const MembershipProfileTagForm: SBRMForm = forwardRef(
  ({ formProps }, ref) => {
    const dispatch = useAppDispatch()
    const { error } = useAppSelector((state) => state.membershipProfileTag)

    return (
      <SBRM.BaseEntityForm
        {...{ ref, formProps }}
        error={error && String(error)}
        formActions={{
          create: Create,
          update: Update,
          delete: Delete,
        }}
        handlers={{
          create: async (values) =>
            dispatch(createMembershipProfileTag(values)).then(() => {
              return true
            }),
          update: async (values) =>
            dispatch(updateMembershipProfileTag(values)).then(() => {
              return true
            }),
          delete: async (values) =>
            dispatch(deleteMembershipProfileTag(values)).then(() => {
              return true
            }),
        }}
      />
    )
  }
)

MembershipProfileTagForm.displayName = 'MembershipProfileTagForm'

export default MembershipProfileTagForm
